export default __webpack_public_path__ + "4eac1911420133d28dbf59a3a4af4e45.svg";